var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7C8.39375 7 9.92857 5.4332 9.92857 3.5C9.92857 1.5668 8.39375 0 6.5 0C4.60625 0 3.07143 1.5668 3.07143 3.5C3.07143 5.4332 4.60625 7 6.5 7ZM8.9 7.875H8.45268C7.85804 8.15391 7.19643 8.3125 6.5 8.3125C5.80357 8.3125 5.14464 8.15391 4.54732 7.875H4.1C2.1125 7.875 0.5 9.52109 0.5 11.55V12.6875C0.5 13.4121 1.07589 14 1.78571 14H11.2143C11.9241 14 12.5 13.4121 12.5 12.6875V11.55C12.5 9.52109 10.8875 7.875 8.9 7.875Z",
    fill: "#9E9288"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSm);
export default __webpack_public_path__ + "static/media/user-sm.406fe177a89821fe913a4f2f5543237b.svg";
export { ForwardRef as ReactComponent };